import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StiiraError } from '@core/models';
import { ErrorService, LayoutService } from '@core/services';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';
import { indicate, keepDialogOpen } from '@shared/helpers';
import { Observable, Subject } from 'rxjs';
import { LeaveReasonsService } from '@core/services/leave-reasons.service';
import { NewLeaveReasonPost } from '@core/models/leave-reasons/leave-reasons-dashboard.model';

@Component({
    selector: 'app-add-new-leave-reason',
    templateUrl: './add-new-leave-reason.component.html',
    styleUrls: ['./add-new-leave-reason.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddNewLeaveReasonComponent implements OnInit {
  static readonly componentName = 'AddNewLeaveReasonComponent';
  
  public form: UntypedFormGroup;
  public isSubmitting$: Subject<boolean>;
  public isMobile$: Observable<boolean>;
  public duplicateMessage: string;
  public position = position;
  public onDragEnded = onDragEnded;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { 
      sysText: any, 
      duplicateName: string,
      sourceId: number
    },
    private leaveReasonService: LeaveReasonsService,
    private errorService: ErrorService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddNewLeaveReasonComponent>,
    private layoutService: LayoutService
  ) {
    this.isSubmitting$ = new Subject();
    this.form = this.fb.group({
      name: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    this.isMobile$ = this.layoutService.isMobile$();
    if(this.data.duplicateName) {
      this.form.controls.name.patchValue(this.data.duplicateName + ' (' + this.data.sysText.copy + ')');
    }

    this.duplicateMessage = this.data.sysText.duplicateMessage?.replace('@[sourceName]', this.data.duplicateName);
  }

  public onSubmit() {
    const newLeaveReasonPost: NewLeaveReasonPost = {
      leaveReasonName: this.form.controls.name.value,
      sourceId: this.data.sourceId
    }
    this.leaveReasonService.postNewLeaveReason(newLeaveReasonPost)
      .pipe(
        indicate(this.isSubmitting$),
        keepDialogOpen(this.dialogRef)
      )
      .subscribe((res) => {
        this.dialogRef.close(res);
      }, (err: StiiraError) => this.errorService.setFormModelStateErrors(this.form, err.modelStateErrors));
  }
}
